const state = {
  viewData: {
    hasPayPwd: 0,
    pfBalance: 0,
    frozenAmount: 0,
    availBal: 0,
    ledgerfrozen: [],
    pfUid: '',

    creditdgBalance: 0, // M幣餘額
    creditdgFrozenAmount: 0,
    creditdgAvailBal: 0,
    creditdgFrozenRows: [],
  }
}

const getters = {
}

const mutations = {
  setViewData (state, value) {
    const frozenAmount = Number(value.frozenAmount) || 0
    const creditdgFrozenAmount = Number(value.creditdgFrozenAmount) || 0

    state.viewData = {
      ...value,
      frozenAmount,
      ledgerfrozen: Array.isArray(value.ledgerfrozen) ? value.ledgerfrozen : [],
      availBal: (Number(value.pfBalance) || 0) - frozenAmount,
      creditdgFrozenAmount,
      creditdgFrozenRows: Array.isArray(value.creditdgFrozenRows) ? value.creditdgFrozenRows : [],
      creditdgAvailBal: (Number(value.creditdgBalance) || 0) - creditdgFrozenAmount,
    }
  },
}

const actions = {
  view ({ state, commit, rootState }, params) {
    return rootState.axios.post('/wallet/profile/v1frontend/profile/view', params, {
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    }).then(res => {
      if (!res.data.error) {
        commit('setViewData', res.data.model)
      }
      return res
    })
  },
  updatePayPwd ({ state, commit, rootState }, params) {
    return rootState.axios.post('/wallet/profile/v1frontend/profile/update-pay-pwd', params, {
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
